import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Build } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import Navigation from './Navigation';
import { servicesContent } from '../content/pages/services';

const Services: React.FC = () => {
  const c = servicesContent;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      {/* Hero Section */}
      <Box sx={{
        color: 'white',
        py: 8,
        bgcolor: 'primary.main',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Beaver Background Image */}
        <Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(/images/beaver-happy-family.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.15,
          zIndex: 0,
        }} />

        <Navigation />

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
              {c.hero.title}
            </Typography>
            <Typography variant="h5" component="h2" sx={{ opacity: 0.9, maxWidth: 800, mx: 'auto', lineHeight: 1.4 }}>
              {c.hero.subtitle}
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Coming Soon Section */}
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Box sx={{ textAlign: 'center' }}>
          <Box sx={{ mb: 4 }}>
            <img
              src="/images/beavers_science.png"
              alt={c.comingSoon.imageAlt}
              style={{ maxWidth: '400px', width: '100%', height: 'auto' }}
            />
          </Box>

          <Build sx={{ fontSize: 64, color: 'primary.main', mb: 3 }} />

          <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
            {c.comingSoon.title}
          </Typography>

          <Typography variant="h6" sx={{ color: "text.secondary", mb: 4, lineHeight: 1.6 }}>
            {c.comingSoon.description1}
          </Typography>

          <Typography variant="body1" sx={{ color: "text.secondary", mb: 6, lineHeight: 1.6 }}>
            {c.comingSoon.description2}
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              href="/docs"
              sx={{ bgcolor: 'primary.main', '&:hover': { bgcolor: 'primary.dark' } }}
            >
              {c.comingSoon.buttons.docs}
            </Button>
            <Button
              variant="outlined"
              size="large"
              href="/pricing"
              sx={{ 
                borderColor: 'primary.main', 
                color: 'primary.main', 
                '&:hover': { bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1) } 
              }}
            >
              {c.comingSoon.buttons.pricing}
            </Button>
            <Button
              variant="outlined"
              size="large"
              href="/contact"
              sx={{ 
                borderColor: 'primary.main', 
                color: 'primary.main', 
                '&:hover': { bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1) } 
              }}
            >
              {c.comingSoon.buttons.contact}
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Services;
